var ObservableTreeNode = require("./src/observable/tree/observableTreeNode.js");
var mixin = require("./src/general.js").mixin;

var AbstractInteractionModel = function(data) {
    this.makeObservableTreeNode();

    this.data = data;
    console.assert(data != null);
};
mixin(AbstractInteractionModel, ObservableTreeNode);

module.exports = AbstractInteractionModel;

AbstractInteractionModel.prototype.getViableElement = function(){
    if (this.data) {
        var el = this.data.getViableElement();
        if (el) return {element: el.element, path: el.path.concat(["__interactionModel"])};
        else return null;
    } else return null;
};

AbstractInteractionModel.prototype.setSelected = function (selected) {
    this.selected(selected);
};

AbstractInteractionModel.prototype.setFocus = function (focus) {
    this.infocus(focus);
};

AbstractInteractionModel.prototype.remove = function() {
    this.data.remove();
};

AbstractInteractionModel.prototype.getPos = function() {
    if (this.data.getPos) return this.data.getPos();
};

AbstractInteractionModel.prototype.setPos = function() {
    if (this.data.setPos) this.data.setPos();
};

AbstractInteractionModel.prototype.move = function(vec) {
    if (this.data.move) this.data.move(vec);
};

AbstractInteractionModel.prototype.rotate = function(angle, center) {
    if (this.data.rotate) this.data.rotate(angle, center);
};

AbstractInteractionModel.prototype.flip = function(flipline) {
    if (this.data.flip) this.data.flip(flipline);
};
